import React, { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import useResponsiveness from '@/hooks/useResponsiveness';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import { useRouter } from 'expo-router';

const AgentsRouteNavigationHeaderRight = React.memo(() => {
  const { t } = useTranslation();
  const { isXS } = useResponsiveness();
  const router = useRouter();

  const handleSearchClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    router.push('/agents/search');
  }, [router]);

  if (!isXS) {
    return null;
  }

  return (
    <NavigationBarButtonContainer rightPadding>
      <NavigationBarButton
        icon="magnifying-glass"
        title={t('pages.agents.searchPlaceholder')}
        onPress={handleSearchClick}
      />
    </NavigationBarButtonContainer>
  );
});

AgentsRouteNavigationHeaderRight.displayName = 'AgentsRouteNavigationHeaderRight';

const AgentsRouteNavigationOptions = {
  title: 'Bots',
  headerTitle: () => null,
  headerBackVisible: false,
  headerRight: () => <AgentsRouteNavigationHeaderRight />
};

export default AgentsRouteNavigationOptions;
